import { fetchRatePlanRoomType } from "./api";

export const roomExtraReducers = (builder) => {
  builder
    .addCase(fetchRatePlanRoomType.pending, (state) => {
      state.loading = true;
      state.optionLoader = true;
      state.status = {
        apiMessage: "",
        apiSuccess: true,
      };
    })
    .addCase(fetchRatePlanRoomType.fulfilled, (state, { payload }) => {
      if (!payload.status.apiSuccess) {
        state.corpCode = "";
      }
      const isActiveRoom = state.roomCounts?.findIndex((room) => room?.isActive);
      state.selectedRooms = state.selectedRooms?.map((room, index) => {
        console.log('room:', room);

        if (isActiveRoom === index) {
          return room; // keep active room as-is
        }

        const roomId = room._id;

        const newData = payload.roomType.find(r => {
          console.log('r1:', r);
          return r._id === roomId;
        });
        console.log('newData:', { ...newData });

        return newData ? { ...newData } : {...room};
      });

      if (isActiveRoom !== -1) {
        console.log("payload.selectedRoom", payload.selectedRoom);
        if (payload.selectedRoom.length > 0) {
          state.selectedRooms[isActiveRoom] = {
            ...state.selectedRooms[isActiveRoom],
            ...payload.selectedRoom[0],
          };
        }
      }
      // if(isActiveRoom !== -1){
      //   state.allOptions2[isActiveRoom] = payload.allOptions;
      // } else {
      //   state.allOptions2[0] = payload.allOptions;
      // }
      state.cancellationPolicy = payload.cancellationPolicy;
      state.isRoomAvailable =payload.isRoomAvailable;
      state.selectedRoom = payload.selectedRoom;
      if(!state.isActiveRoomSwitch){
        state.allOptions = payload.allOptions;
        state.allOptions2[isActiveRoom] = payload.allOptions;
      }else{
        if(payload.allOptions.length > 1){
          state.allOptions = state.allOptions2[isActiveRoom];
        }else{
          state.allOptions = payload.allOptions;
        }
      }
      state.initialOptions = payload.allOptions;
      state.firstAllOptions = payload.allOptions;
      state.isCorpCode = payload.isCorpCode;
      state.ratePlans = payload.ratePlans;
      state.roomType = payload.roomType;
      state.timeSpan = payload.timeSpan;
      state.status = payload.status;
      state.ratePlanCategory = "";
      state.optionLoader = false;
      state.packageDisabledIds = []
      
      if (Object.keys(payload.groupCodeDetails).length > 0) {
        state.groupCode = payload.groupCodeDetails.groupCode;
        state.groupCodeDetails = payload.groupCodeDetails;
      }

      state.loading = false;
      // reset the switch flag after handling
      state.isActiveRoomSwitch = false;
    })
    .addCase(fetchRatePlanRoomType.rejected, (state, { payload }) => {
      state.loading = payload.loading || false;
      state.optionLoader = payload.optionLoader || false;
      state.status = payload?.status || { apiMessage: "", apiSuccess: true };
      state.isRoomAvailable = payload.isRoomAvailable;
    });
};
